import { useCallback, useSyncExternalStore } from 'react';

import { realtime, type Presence } from './client';

const NOBODY: Presence[] = [];

/**
 * Кто сейчас в канале записи. Сервер присылает полный список при каждой
 * перемене, хранить и сводить ничего не нужно: список лежит в клиенте, и
 * второй слушатель того же канала получает его сразу, а не со следующей
 * переменой.
 */
export function usePresence(channel: string | undefined): Presence[] {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (channel === undefined || channel === '') {
        return () => undefined;
      }

      return realtime.subscribe(channel, (event) => {
        if (event.event === 'presence') {
          notify();
        }
      });
    },
    [channel],
  );

  return useSyncExternalStore(
    subscribe,
    () => (channel === undefined ? NOBODY : realtime.presenceOf(channel)),
    () => NOBODY,
  );
}
